// @ts-check
import { Link } from 'react-router-dom';
import StatCard from '../StatCard';

const CARDS = [
  ['add_to_cart', 'Add to cart'],
  ['checkout_started', 'Checkouts started', 'visitors'],
  ['dau', 'DAU'],
  ['mau', 'MAU'],
];

/** Four stat cards: 2x2 on mobile, one row on lg. Spans the full dashboard grid. Each links to the analytics page. */
export default function TrafficRow({ block }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 min-w-0 md:col-span-2 lg:col-span-3">
      {CARDS.map(([key, label, caption]) => {
        const s = block.data?.[key] || { value: 0, delta_pct: null, spark: [] };
        return (
          <Link key={key} to={block.href} className="block rounded-lg hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <StatCard
              label={label}
              caption={caption}
              value={s.value}
              deltaPct={s.delta_pct}
              spark={s.spark}
              partialLast={s.partial_last}
            />
          </Link>
        );
      })}
    </div>
  );
}
